import { createReducer } from 'typesafe-actions';
import produce from 'immer';

import * as Actions from '../actions/menuAction';
import { MenuModelState, initMenuModel } from '../models/menuModel';

export const menuReducer = createReducer<MenuModelState, Actions.MenuAction>(
  initMenuModel
).handleAction(Actions.dispatchTopMenu, (state, action) =>
  produce(state, draft => {
    const topMenuCd = action.payload;
    draft.topMenuCd = topMenuCd;
  })
);
// .handleAction(Actions.termsList.success, (state, action) =>
//   produce(state, draft => {
//     const res = action.payload;
//     draft.termsList = res;

//     // draft.terms = res;
//   })
// );
